import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
}
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallAppButton() {
  const [hidden, setHidden] = useState(true);
  useEffect(() => { setHidden(standalone()); }, []);
  if (hidden) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const r = await deferred.userChoice;
      deferred = null;
      if (r.outcome === "accepted") setHidden(true);
    } else if (isIos()) {
      toast.info("Tap the Share button in Safari, then choose \"Add to Home Screen\".", { duration: 8000 });
    } else {
      toast.info("Open your browser menu (⋮) and choose \"Add to Home screen\" or \"Install app\".", { duration: 8000 });
    }
  };
  return (
    <button onClick={install} data-testid="install-app-button" className="flex items-center gap-2 text-sm text-slate-700 font-semibold hover:text-emerald-700 transition-colors mb-2">
      <Smartphone className="h-4 w-4" /> Add GrantVerify to home screen
    </button>
  );
}
